import Quimbee from "quimbee"
import HubSpotContact from "components/hubspot_contact"
import { waitForQuimbeeDataKey } from "controllers/quimbee_data_controller"

window.addEventListener('DOMContentLoaded', async () => {
  await waitForQuimbeeDataKey("hubSpotChatEnabled")

  if (Quimbee.data.hubSpotChatEnabled) {
    const hubSpotContact = new HubSpotContact()
    await hubSpotContact.initialize()
    hubSpotContact.load()
  }
})
